import { array, record, string } from 'io-ts/Decoder';

export const Reactions = record(array(string));
